import React, { useState } from "react";
import Modal from "../../../shared/components/modal/modal";
import Button from "../../../shared/components/button/button";
import { PaidProductDetails, Tenant } from "../../../shared/interfaces/model/tenant.interface";
import { User } from "../../../shared/interfaces/model/user.interface";

interface ProductMemberDetails2Props {
    tenant: Tenant;
    currentProduct: PaidProductDetails;
    userList: User[];
}

export const ProductMemberDetails2 = ({ tenant, currentProduct, userList }: ProductMemberDetails2Props) => {
    const [updateMember, setUpdateMember] = useState<string>();
    const [showInviteMember, setShowInviteMember] = useState<boolean>(false);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [showDelete, setShowDelete] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [memberEmail, setMemberEmail] = useState<string>('');
    const [alreadyExist, setAlreadyExist] = useState<boolean>(false);
  
    const handleCloseModal = () => {
      setShowInviteMember(false);
      setShowUpdateModal(false);
      setShowDelete(false);
      setUpdateMember('');
    };
  
    const inviteMember = () => {
      setLoading(true);
      if (memberEmail === '') {
        setLoading(false);
        return;
      }
      // check if email already exists
      const exist = userList.find((user: any) => user.email === memberEmail);
      if (exist) {
        setAlreadyExist(true);
        setLoading(false);
        return;
      }
      // fetchData();
      // sendData();
      // setShowModalOps(true);
      setLoading(false);
    };
  
    return (
      <>
        {
          showInviteMember && (
            <Modal handleClose={handleCloseModal}>
              <div className="space-y-6  px-5 pt-3 pb-6">
                <h3 className="text-xl font-medium text-gray-900 dark:text-white">Sign in to our platform</h3>
                <div>
                  {/* <TextInput id="email" placeholder="name@company.com" required onChange={(e) => setInviteMemberEmail(e.target.value)} /> */}
                  <label htmlFor="signin-email">User Email:</label>
                  <input
                    placeholder="Scrivi email..."
                    name="email"
                    id="signin-email"
                    type="text"
                    value={memberEmail}
                    title="Inserire campo"
                    required
                    onChange={(e) => setMemberEmail(e.target.value)}
                  />
                </div>
                <h5>{alreadyExist ? `Attenzione: Non è possibile aggiornare perché mail esiste già!!!` : null}</h5>
                <div className="w-full mb-7">
                  <Button
                    title={!loading ? "Aggiungi utente" : "Creazione Utente"}
                    disabled={loading}
                    onClickHandler={inviteMember}
                  />
                  {loading && <i className="fa fa-refresh fa-spin" />}
                </div>
              </div>
            </Modal>
          )
        }
  
        {showUpdateModal && (
          <Modal handleClose={handleCloseModal}>
            <div className="space-y-6  px-5 pt-3 pb-6">
              <h3>Aggiorna questo Utente:</h3>
              <div>
                <label htmlFor="signin-email">Email da aggiornare:</label>
                <input
                  placeholder="Aggiorna Email dell'Utente..."
                  name="email"
                  id="signin-email"
                  type="text"
                  value={memberEmail}
                  title="Inserire campo"
                  required
                  onChange={(e) => setMemberEmail(e.target.value)}
                />
              </div>
              <h5>{alreadyExist ? "Attenzione:" : null}</h5>
              {/* <h6>{alreadyExist ? messageWarning : null}</h6> */}
              <div className="row">
                <div className="col-xs-6">
                  <Button
                    disabled={alreadyExist || loading}
                    title={!loading ? "Aggiorna" : "Aggiornamento Utente"}
                    onClickHandler={() => {
                      // fetchData();
                      // const updateUserObj = {
                      //   tenantId: tenantDocId,
                      //   usermail: oldEmail,
                      //   newMail: email,
                      // };
                      // updateUserRow(updateUserObj);
                      // setShowModalOps(true);
                    }}
                  />
                  {loading && <i className="fa fa-refresh fa-spin" />}
                </div>
                <div className="col-xs-6">
                  <Button title="Elimina" onClickHandler={handleCloseModal} />
                </div>
              </div>
            </div>
          </Modal>
        )}
        {showDelete && (
          <Modal handleClose={handleCloseModal}>
            <div>
              <h3 className="text-align-center">
                E&#39; sicuro di voler eliminare l&#39;utente<br />
                <q>{memberEmail}</q> ?
              </h3>
              <div className="row">
                <div className="col-xs-6">
                  <Button
                    title={!loading ? "Si" : "Cancellazione Utente"}
                    disabled={loading}
                    onClickHandler={() => {
                      // fetchData();
                      // const deleteUserObj = {
                      //   tenantId: tenantDocId,
                      //   usermail: email,
                      // };
                      // deleteUserRow(deleteUserObj);
                      // setShowModalOps(true);
                    }}
                  />
                  {loading && <i className="fa fa-refresh fa-spin" />}
                </div>
                <div className="col-xs-6">
                  <Button title="No" onClickHandler={handleCloseModal} />
                </div>
              </div>
            </div>
          </Modal>
        )}
  
      </>
    );
  };